import { batchActions } from './utils';
import { setData } from './data';
import { setStatus, unsetStatus } from './status';
import { LOADING, ERROR, selectPodcastListenersStatus, selectDateRange } from './selectors';
import { toJSON, PODCASTERS_SERVICE } from '../lib/Request';
import { DateRangeWithLabel, Thunk, Listener } from '../types';

export const loadPodcastListeners = (podcastId: string): Thunk => async (
  dispatch,
  getState,
  { request },
) => {
  const key = 'podcastListeners';

  const { startDate, endDate } = selectDateRange(getState()) as DateRangeWithLabel;
  const endpoint = `${PODCASTERS_SERVICE}/v0/shows/${podcastId}/listeners?start=${startDate}&end=${endDate}`;

  /* istanbul ignore next */
  if (selectPodcastListenersStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [key]: LOADING }, 'audience/LOAD_PODCAST_LISTENERS_REQUEST'));

  try {
    const { counts: data }: { counts: Listener[] } = await request.get(endpoint).then(toJSON);

    dispatch(
      batchActions(
        [setData({ [key]: data }), unsetStatus([key])],
        'audience/LOAD_PODCAST_LISTENERS_SUCCESS',
      ),
    );
  } catch (err) {
    switch (err.name) {
      case 'ResponseError':
      case 'TokenError': {
        dispatch(setStatus({ [key]: ERROR }, 'audience/LOAD_PODCAST_LISTENERS_ERROR'));
        break;
      }

      /* istanbul ignore next */
      default:
        throw err;
    }
  }
};
